module.exports = __webpack_public_path__ + "img/streak50.5b96cfe6.png";